// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"95fb46f4","77":"99e19ed7","80":"355289c3","203":"a9a6eb83","476":"5e3679c1","650":"b38058cc","787":"c5e9176a","791":"ea97b4dd"}[chunkId] + ".chunk.js";
};